import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../../messages'
import { Grid } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { configContext } from '../../../utils/StandardReducer'
import { TubeProduct, TubeProperties } from '../../../utils/StandardMTOEnum'
import { checkValidKey } from '@src/routes/Configurators/utils/util'

const useStyles = makeStyles((theme: Theme) => {
  return {
    contentWrapper: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(2, 5, 5),
      marginBottom: theme.spacing(-5),
    },
    head: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightBold,
      margin: theme.spacing(2, 0),
      marginTop: theme.spacing(-1),
    },
    subHead: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightBold,
      margin: theme.spacing(2, 0),
    },
    shippingHead: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightBold,
      margin: theme.spacing(2, 0),
      marginBottom: theme.spacing(4),
    },
    shippingSubHead: {
      fontSize: theme.typography.pxToRem(14),
      margin: theme.spacing(2, 0),
      marginBottom: theme.spacing(12),
    },
    label: {
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(14),
      marginBottom: theme.spacing(2),
    },
    cardContent: {
      padding: theme.spacing(0),
    },
    table: {
      paddingTop: theme.spacing(1),
    },
    cell: {
      paddingLeft: theme.spacing(1),
    },
  }
})

const SpecificationsAndShipping = (props) => {
  const classes = useStyles()
  const { state } = React.useContext(configContext)
  const intl = useIntl()
  const { specificationsData, productType } = props
  const { sessionData } = state
  const [formatValue, setFormatValue] = React.useState(
    sessionData[state.currentOligoIndex].format
  )
  const [purificationValue, setPurificationValue] = React.useState(
    sessionData[state.currentOligoIndex].purification
  )
  const [concentrationValue, setConcentrationValue] = React.useState(
    sessionData[state.currentOligoIndex].concentration
  )
  const [amountValue, setAmountValue] = React.useState(
    sessionData[state.currentOligoIndex].amount
  )
  const [shippingValue, setShippingValue] = React.useState(
    sessionData[state.currentOligoIndex].shipping
  )

  const populateSpecificationValues = (specificationsData) => {
    return specificationsData.specifications.map((specificationList) => {
      if (specificationList.categoryName === TubeProperties.Format) {
        setFormatValue(specificationList.specificationModifications[0].value)
      } else if (
        specificationList.categoryName === TubeProperties.Purification
      ) {
        setPurificationValue(
          specificationList.specificationModifications[0].value
        )
      } else if (
        specificationList.categoryName === TubeProperties.Concentration
      ) {
        setConcentrationValue(
          specificationList.specificationModifications[0].value
        )
      } else if (specificationList.categoryName === TubeProperties.Amount) {
        setAmountValue(specificationList.specificationModifications[0].value)
      } else if (specificationList.categoryName === TubeProperties.Shipping) {
        setShippingValue(specificationList.specificationModifications[0].value)
      }

      return null
    })
  }

  const populateSpecification = (specificationsData, specificationType) => {
    return specificationsData.specifications.map((specificationList) => {
      if (specificationList.categoryName === specificationType) {
        return intl.formatMessage(
          checkValidKey(
            messages[
              specificationList.specificationModifications[0].displayName
            ],
            specificationList.specificationModifications[0].displayName
          )
        )
      }
      return null
    })
  }

  React.useEffect(() => {
    populateSpecificationValues(specificationsData)
    state.sessionData[state.currentOligoIndex].format = formatValue
    state.sessionData[state.currentOligoIndex].purification = purificationValue
    state.sessionData[state.currentOligoIndex].concentration =
      concentrationValue
    state.sessionData[state.currentOligoIndex].amount = amountValue
    state.sessionData[state.currentOligoIndex].shipping = shippingValue
    // TODO: need a test before we refactor these dependencies
  }, [state.currentOligoIndex, sessionData[state.currentOligoIndex].sequence])

  return (
    <div>
      {productType === TubeProduct.PureSimple ? (
        <div className={classes.contentWrapper}>
          <Grid container>
            <Grid item sm={6}>
              <h4 className={classes.head}>
                <FormattedMessage {...messages.CONF_SPECIFICATIONS} />
              </h4>
              <table className={classes.table}>
                <tr>
                  <td>
                    <div className={classes.subHead}>
                      <FormattedMessage {...messages.CONF_AMOUNT_EASY_OLIGO} />
                    </div>
                  </td>
                  <td className={classes.cell}>
                    {populateSpecification(
                      specificationsData,
                      TubeProperties.Amount
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className={classes.subHead}>
                      <FormattedMessage
                        {...messages.CONF_PURIFICATION_EASY_OLIGO}
                      />
                    </div>
                  </td>
                  <td className={classes.cell}>
                    {populateSpecification(
                      specificationsData,
                      TubeProperties.Purification
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className={classes.subHead}>
                      <FormattedMessage {...messages.CONF_FORMAT_EASY_OLIGO} />
                    </div>
                  </td>
                  <td className={classes.cell}>
                    {populateSpecification(
                      specificationsData,
                      TubeProperties.Format
                    )}
                  </td>
                </tr>
              </table>
            </Grid>
          </Grid>
        </div>
      ) : (
        <div className={classes.contentWrapper}>
          <Grid container>
            <Grid item sm={6}>
              <h4 className={classes.head}>
                <FormattedMessage {...messages.CONF_SPECIFICATIONS} />
              </h4>
              <table className={classes.table}>
                <tr>
                  <td>
                    <div className={classes.subHead}>
                      <FormattedMessage {...messages.CONF_FORMAT_EASY_OLIGO} />
                    </div>
                  </td>
                  <td className={classes.cell}>
                    {populateSpecification(
                      specificationsData,
                      TubeProperties.Format
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className={classes.subHead}>
                      <FormattedMessage
                        {...messages.CONF_PURIFICATION_EASY_OLIGO}
                      />
                    </div>
                  </td>
                  <td className={classes.cell}>
                    {populateSpecification(
                      specificationsData,
                      TubeProperties.Purification
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className={classes.subHead}>
                      <FormattedMessage
                        {...messages.CONF_CONCENTRATION_EASY_OLIGO}
                      />
                    </div>
                  </td>
                  <td className={classes.cell}>
                    {populateSpecification(
                      specificationsData,
                      TubeProperties.Concentration
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className={classes.subHead}>
                      <FormattedMessage {...messages.CONF_AMOUNT_EASY_OLIGO} />
                    </div>
                  </td>
                  <td className={classes.cell}>
                    {populateSpecification(
                      specificationsData,
                      TubeProperties.Amount
                    )}
                  </td>
                </tr>
              </table>
            </Grid>
          </Grid>
        </div>
      )}

      <div className={classes.contentWrapper}>
        <Grid container>
          <Grid item sm={6}>
            <h4 className={classes.shippingHead}>
              <FormattedMessage {...messages.CONF_SHIPPING_EASY_OLIGO} />
            </h4>
            <div className={classes.shippingSubHead}>
              <b>
                {populateSpecification(
                  specificationsData,
                  TubeProperties.Shipping
                )}
              </b>
              <FormattedMessage
                {...messages.CONF_ROOM_TEMPERATURE_EASY_OLIGO}
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}

export default SpecificationsAndShipping
